export default class ProductModel {
  constructor (
    id,
    article,
    amount,
    imagePath,
    imageId,
    quantityStep,
    warehouseStock,
    hasFavorites,
    name,
    price,
    bestPrice,
    oldPrice,
    isBasic,
    isActive,
    weight,
    length,
    width,
    height,
    url,
    priceType = '',
    isOrder = false,
  ) {
    this.id = id
    this.article = article
    this.amount = amount
    this.imagePath = imagePath    
    this.imageId = imageId
    this.quantityStep = quantityStep
    this.warehouseStock = warehouseStock
    this.hasFavorites = hasFavorites
    this.name = name
    this.price = price
    this.bestPrice = bestPrice
    this.oldPrice = oldPrice
    this.isBasic = isBasic
    this.isActive = isActive
    this.weight = weight
    this.length = length
    this.width = width
    this.height = height
    this.url = url
    this.priceType = priceType
    this.isOrder = isOrder
  }
}